export {
  get as getMerchants,
  $items as $merchants,
  $totalItems as $totalMerchants,
  setRequestOptions as setMerchantsRequestOptions,
  $requestOptions as $merchantsRequestOptions,
  $getStatus as $getMerchantsStatus,
  clearError as clearMerchantsError,
} from './model'
